import React from "react";
import classNames from "classnames";

import { useIsElementHovered } from "@common/elementHover";
import { useConstraints } from "../../../constraintsOverlay";
import { Props } from "./types";
import { Handle } from "./handle";
import styles from "./styles.scss";

function Constrainable({
  element,
  elementWidth,
  constraints,
  children,
}: Props) {
  const { origin, target } = useConstraints();
  const isHovered = useIsElementHovered(element.uuid);

  return (
    <div
      className={classNames(styles.constrainable, {
        [styles.origin]: origin && element.uuid === origin.uuid,
        [styles.target]: target && element.uuid === target.uuid,
        [styles.hovered]: isHovered,
      })}
    >
      <Handle
        element={element}
        elementWidth={elementWidth}
        constraints={constraints}
        direction="left"
      />
      {children}
      <Handle
        element={element}
        elementWidth={elementWidth}
        constraints={constraints}
        direction="right"
      />
    </div>
  );
}

export { Constrainable };
